export type AtlasAssetKind = 'terrain' | 'object' | 'path' | 'entity' | 'ui' | 'effect';

export interface AtlasPixelRect {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

export interface AtlasUvRect {
  readonly u0: number;
  readonly v0: number;
  readonly u1: number;
  readonly v1: number;
}

export interface AtlasPivot {
  readonly x: number;
  readonly y: number;
}

export interface AtlasOffset {
  readonly x: number;
  readonly y: number;
}

export interface AtlasPage {
  readonly id: string;
  readonly width: number;
  readonly height: number;
  readonly image: CanvasImageSource;
}

export interface AtlasFrame {
  readonly id: string;
  readonly sourceId: string;
  readonly kind: AtlasAssetKind;
  readonly pageId: string;
  readonly pixelRect: AtlasPixelRect;
  readonly uvRect: AtlasUvRect;
  readonly drawWidth: number;
  readonly drawHeight: number;
  readonly pivot: AtlasPivot;
  readonly offset: AtlasOffset;
  readonly animated: boolean;
  readonly animationGroupId?: string;
  readonly sourcePath?: string;
}

export interface AtlasAnimationFrame {
  readonly frameId: string;
  readonly durationMs: number;
}

export interface AtlasAnimationGroup {
  readonly id: string;
  readonly loop: boolean;
  readonly frames: readonly AtlasAnimationFrame[];
}

export interface AtlasManifest {
  readonly source: 'runtime' | 'prebuilt';
  readonly builtAtMs: number;
  readonly pages: readonly AtlasPage[];
  readonly frames: readonly AtlasFrame[];
  readonly animationGroups: readonly AtlasAnimationGroup[];
}

export function createAtlasFrameId(kind: AtlasAssetKind, sourceId: string): string {
  return `${kind}:${sourceId}`;
}

export function createAtlasUvRect(rect: AtlasPixelRect, pageWidth: number, pageHeight: number): AtlasUvRect {
  return {
    u0: rect.x / pageWidth,
    v0: rect.y / pageHeight,
    u1: (rect.x + rect.width) / pageWidth,
    v1: (rect.y + rect.height) / pageHeight,
  };
}
